module.exports = require("vuetify/lib/components/VBottomSheet");